import { Link, useLocation } from "react-router-dom";
import { getArticleSiblingSlug } from "../data/articles";

const STATIC_SIBLINGS = {
  "/": "/de",
  "/de": "/",
  "/ikea-assembly-munich": "/ikea-moebelmontage-muenchen",
  "/ikea-moebelmontage-muenchen": "/ikea-assembly-munich",
  "/services": "/de/leistungen",
  "/de/leistungen": "/services",
  "/faq": "/de/faq",
  "/de/faq": "/faq",
  "/more": "/de/mehr",
  "/de/mehr": "/more",
  "/privacy": "/de/datenschutz",
  "/de/datenschutz": "/privacy",
};

const resolveAlt = (pathname) => {
  if (STATIC_SIBLINGS[pathname]) return STATIC_SIBLINGS[pathname];

  // Article routes: /more/:slug <-> /de/mehr/:slug
  const enArt = pathname.match(/^\/more\/([^/]+)$/);
  if (enArt) {
    const sib = getArticleSiblingSlug("en", enArt[1]);
    return sib ? `/de/mehr/${sib}` : "/de/mehr";
  }
  const deArt = pathname.match(/^\/de\/mehr\/([^/]+)$/);
  if (deArt) {
    const sib = getArticleSiblingSlug("de", deArt[1]);
    return sib ? `/more/${sib}` : "/more";
  }
  return null;
};

export const LangSwitcher = () => {
  const { pathname } = useLocation();
  const isDe =
    pathname === "/de" ||
    pathname.startsWith("/de/") ||
    pathname === "/ikea-moebelmontage-muenchen";
  const altPath = resolveAlt(pathname) || (isDe ? "/" : "/de");

  return (
    <Link
      to={altPath}
      className="text-xs tag-line text-[#5C635A] hover:text-[#1C3326] transition-colors border border-[#E5E2DC] px-2.5 py-1 hover:border-[#1C3326]"
      data-testid="lang-switcher"
      aria-label={isDe ? "Switch to English" : "Sprache wechseln auf Deutsch"}
    >
      {isDe ? "EN" : "DE"}
    </Link>
  );
};
